import DataDisplayRowI from "../DataDisplayRowI";
import getStaffRow from "../DataDisplayRow/StaffRow";
import DataDisplayTable from "../DataDisplayTable";

export class StaffTable extends DataDisplayTable {
    #row!: DataDisplayRowI

    generateRow(): DataDisplayRowI {
        this.#row = getStaffRow()
        return this.#row
    }
}

let staffTable: StaffTable | null = null;

export default function getStaffTable(): StaffTable {
    if (staffTable === null)
        staffTable = new StaffTable()
    return staffTable
}